import React from "react";
import PropTypes from "prop-types";
import ClinicalSampleCnv from "../../../../../models/ClinicalSampleCnv";
import Limiter from "../../../../../components/atoms/Limiter";
import Btn from "../../../../../components/atoms/Btn";

function RepeatExpansionInfo({ item }) {
  return (
    <>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-32">Genes</div>
        <div className=" tw-whitespace-normal tw-max-w-80">
          <Limiter
            items={item?.genes || []}
            limit={1}
            ExpandLink={({ remaining, toggle, isExpanded }) => (
              <Btn className="tw-mx-2 tw-text-primary link" onSubmit={toggle}>
                {isExpanded ? `show fewer` : `+ ${remaining} more`}
              </Btn>
            )}
            renderContent={({ items }) => (
              <span>{items.join(", ") || "-"}</span>
            )}
          />
        </div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-32">Repeat Unit</div>
        <div className="tw-max-w-80">{item?.repeatUnit || "-"}</div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-32">Sample Repeats</div>
        <div className="tw-max-w-80">{item?.sampleRepeats || "-"}</div>
      </div>
      <div className="tooltip-row tw-items-center">
        <div className="tooltip-label tw-w-32">Min. Pathogenic Repeats</div>
        <div className="tw-max-w-80">{item?.minPathoRepeats || "-"}</div>
      </div>
    </>
  );
}

RepeatExpansionInfo.propTypes = {
  item: PropTypes.instanceOf(ClinicalSampleCnv).isRequired,
};

export default RepeatExpansionInfo;
